export class GetDomainResult {
    manage = "";
    manageInside = "";
}
